var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide"}},[_c('div',{staticClass:"button-menu",class:{'untouchable': _vm.disable},on:{"click":_vm.openMenu}},[_c('icon-menu')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }